export * from './lib/shared-current-user-name.module';
